import React from "react";
import "./CartDrawer.css";
import { Link } from "react-router-dom";

function CartDrawer({ cartItems, cartOpen, onClose, onRemove }) {
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const price = item.product?.price || 0;
      const qty = item.quantity || 0;
      return total + price * qty;
    }, 0);
  };

  const amountForFreeShipping = 50;
  const currentTotal = calculateTotal();
  const amountRemaining = amountForFreeShipping - currentTotal;

  return (
    <div className={`cart-drawer ${cartOpen ? "open" : ""}`}>
      <div className="cart-header">
        <h2>Cart</h2>
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="shipping-banner">
        {amountRemaining > 0 ? (
          <>
            <p>
              Spend <strong>£{amountRemaining.toFixed(2)}</strong> more and get
              free shipping!
            </p>
            <div className="shipping-bar">
              <div
                className="fill"
                style={{
                  width: `${Math.min(
                    (currentTotal / amountForFreeShipping) * 100,
                    100
                  )}%`,
                }}
              />
            </div>
          </>
        ) : (
          <p>
            <strong>Congratulations!</strong> You qualify for free shipping.
          </p>
        )}
      </div>

      <div className="cart-items">
        {cartItems.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          cartItems.map((item, index) => (
            <div key={index} className="cart-item">
              <img
                src={item.product?.images?.[0] || "/images/placeholder.png"}
                alt={item.product?.name || "Product image"}
                className="cart-thumb"
              />
              <div className="details">
                <p>{item.product?.name || "Unnamed Product"}</p>
                <p>Size: {item.size || "N/A"}</p>
                <p>Qty: {item.quantity || 1}</p>
                <p>
                  £
                  {item.product?.price && item.quantity
                    ? (item.product.price * item.quantity).toFixed(2)
                    : "0.00"}
                </p>
                <button onClick={() => onRemove(index)}>Remove</button>
              </div>
            </div>
          ))
        )}
      </div>

      {cartItems.length > 0 && (
        <div className="cart-footer">
          <p>
            <strong>Total:</strong> £{currentTotal.toFixed(2)}
          </p>
          <Link to="/checkout">
            <button>Checkout</button>
          </Link>
        </div>
      )}
    </div>
  );
}

export default CartDrawer;